import { useEffect, useState } from 'react';
import { default as useRequest } from "@pb/utils/reactHooks/useRequest";
import { getLocale } from "@pb/utils/locale";
export const useGetMatchingSet = (articleNumber) => {
    const locale = getLocale();
    const baseUrl = `/recos/relatedarticles/v1/${locale}/articles/${articleNumber}`;
    const { data: matchingSetResponse, isRequestMade: isMatchingSetRequestMade, error: matchingSetRequestError, } = useRequest(baseUrl, undefined, process.env.IS_MATCHING_SET_ENABLED !== 'enabled');
    return { matchingSetResponse, isMatchingSetRequestMade, matchingSetRequestError };
};
export const useGetMatchingSetAppeaser = (articleNumber, enabled) => {
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [response, setResponse] = useState();
    useEffect(() => {
        var _a, _b;
        if (enabled) {
            setLoading(true);
            (_b = (_a = window === null || window === void 0 ? void 0 : window.appeaser) === null || _a === void 0 ? void 0 : _a.WaitFor) === null || _b === void 0 ? void 0 : _b.matchingSet(articleNumber).then((res) => {
                setLoading(false);
                setResponse(res);
            }).catch((err) => {
                setLoading(false);
                setError(err);
            });
        }
    }, [articleNumber, enabled]);
    return { loading, error, response };
};
//# sourceMappingURL=useGetMatchingSet.js.map